export const BASE_TRANSACTIONS_QUERY_KEY = "transactions"
export const BASE_TRANSACTIONS_FEED_QUERY_KEY =
  "transactionsFeed"
export const BASE_PRODUCTS_QUERY_KEY = "products"
export const BASE_PRODUCT_MODIFIERS_QUERY_KEY =
  "productModifiers"
export const BASE_CATEGORIES_QUERY_KEY = "categories"
export const BASE_CASHIERS_QUERY_KEY = "cashiers"
export const BASE_DEVICES_QUERY_KEY = "devices"
export const BASE_ORDERS_QUERY_KEY = "orders"
export const BASE_Z_REPORTS_QUERY_KEY = "zReports"
export const BASE_DONATIONS_QUERY_KEY = "donations"
export const BASE_USERS_QUERY_KEY = "users"

export const BASE_GRATUITY_REPORT_QUERY_KEY =
  "gratuityReport"
export const BASE_GRATUITY_SUMMARY_REPORT_QUERY_KEY =
  "gratuitySummaryReport"
export const BASE_GRATUITY_CASHIER_REPORT_QUERY_KEY =
  "gratuityCashierReport"
export const BASE_OVERVIEW_REPORT_QUERY_KEY =
  "overviewReport"
export const BASE_SUMMARY_REPORT_QUERY_KEY = "summaryReport"
export const BASE_PRODUCT_SALES_REPORT_QUERY_KEY =
  "productSalesReport"
export const BASE_TRANSACTION_REPORT_QUERY_KEY =
  "transactionReport"
export const BASE_TOP_PRODUCTS_REPORT_QUERY_KEY =
  "topProductsReport"

export const BASE_BUSINESS_FUNDING_CONFIG_QUERY_KEY =
  "businessFundingConfig"
export const BASE_DONATION_SETTINGS_QUERY_KEY =
  "donationSettings"
export const BASE_CURRENT_ORGANIZATION_CONFIG_QUERY_KEY =
  "current_org_config"
export const BASE_GRATUTIY_OPTIONS_QUERY_KEY =
  "gratuityOptions"

export const BASE_PRODUCT_IMPORT_QUERY_KEY =
  "productImports"

export const BASE_MERCHANT_GROUP_TRANSACTION_REPORT_QUERY_KEY =
  "merchantGroup:transactionReport"
export const BASE_MERCHANT_GROUP_TRANSACTIONS_BY_MERCHANT_REPORT_QUERY_KEY =
  "merchantGroup:transactionsByMerchantReport"
export const BASE_MERCHANT_GROUP_SUMMARY_REPORT_QUERY_KEY =
  "merchantGroup:summaryReport"
export const BASE_MERCHANT_GROUP_LAST_FIVE_TRANSACTIONS_QUERY_KEY =
  "merchantGroup:lastFiveTransactions"
export const BASE_MERCHANT_GROUP_USERS_QUERY_KEY =
  "merchantGroup:users"
export const BASE_MERCHANT_GROUP_MERCHANTS_QUERY_KEY =
  "merchantGroup:merchants"
export const BASE_MERCHANT_GROUP_CURRENT_ORGANIZATION_CONFIG_QUERY_KEY =
  "merchantGroup:current_org_config"
export const BASE_MERCHANT_GROUP_TERMINALS_QUERY_KEY =
  "merchantGroup:terminals"

export const NEXT_NOTIFICATION_QUERY_KEY =
  "nextNotification"
export const PRODUCT_TAG_QUERY_KEY = "productTags"
